(ns ui.view.counterparty-diligence.responder-form.event
  (:require
   [cljs-http.client :as http]
   [cljs.core.async :as async]
   [clojure.set :as set]
   [clojure.walk :as walk]
   [common.localization :as loc]
   [common.schema.entities.counterparty-diligence.templates.registry :as cd-template-registry]
   [common.schema.entities.counterparty-diligence.templates.util :as template-util]
   [common.schema.entities.counterparty-diligence.templates.validation :as validation]
   [common.util :as cu]
   [frontend.global-events.toast :as toast]
   [oops.core :as oops]
   [potpuri.core :as p]
   [re-frame.core :as rf]
   [ui.util :as uu]
   [ui.view.counterparty-diligence.pdf-util :as pdf-util]
   [ui.view.counterparty-diligence.responder-form.model :as model]
   [ui.view.sheets.event :as sheet-event]))

(defn api-path
  [path]
  (str "/counterparty-diligence/api" path))

(defonce save-answers-timeout-atom (atom nil))

(rf/reg-fx
 ::trigger-save-answers-timeout
 (fn [ctx]
   (when-let [prev-timeout @save-answers-timeout-atom]
     (js/clearTimeout prev-timeout))
   (let [timeout (js/setTimeout (fn []
                                  (rf/dispatch [::save-answers ctx]))
                                1000)]
     (reset! save-answers-timeout-atom timeout))))

(rf/reg-event-fx
 ::initialize
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [state-path process-id template answers
                            submitted? attachments-by-id tenant-user-access?
                            e-signature-required? view-mode date-format lang-kw] :as _args}]]
   (let [answers (if (and e-signature-required?
                          (-> answers :signatories empty?))
                   (assoc answers :signatories [{:full-name "" :email ""}])
                   answers)]
     {:db (-> db
              (assoc-in (model/root?-full-path state-path) true)
              (assoc-in (model/loading-full-path state-path) false)
              (assoc-in (model/language-full-path state-path) (or lang-kw :en))
              (assoc-in (model/process-id-full-path state-path) process-id)
              (assoc-in (model/answers-full-path state-path) answers)
              (assoc-in (model/initial-answers-full-path state-path) answers)
              (assoc-in (model/submitted-full-path state-path) submitted?)
              (assoc-in (model/edit-mode-full-path state-path) true)
              (assoc-in (model/template-full-path state-path) template)
              (assoc-in (model/attachments-full-path state-path) attachments-by-id)
              (assoc-in (model/e-signature-required-full-path state-path) e-signature-required?)
              (assoc-in (model/view-mode-full-path state-path) view-mode)
              (assoc-in (model/date-format-full-path state-path) date-format)
              (assoc-in (model/autosave-on-full-path state-path) (not submitted?))
              (assoc-in (model/form-available-full-path state-path) true)
              (assoc-in (model/tenant-user-access-full-path state-path) tenant-user-access?)
              (assoc-in (model/touched-fields-full-path state-path) #{})
              (model/update-field-visibilities {:state-path state-path})
              (model/update-field-errors {:state-path state-path}))})))

(rf/reg-event-fx
 ::load-process-success
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [state-path]} resp]]
   (let [data (-> resp :body :body)
         _ (js/console.log "Load process " data)
         {:keys [form-available? template-id process-id answers submitted?
                 e-signature-required? roles
                 attachments date-format]} data
         template (cd-template-registry/get-template template-id)
         guest-role-only? (= roles #{:role/guest-counterparty-diligence})
         attachments-by-id (p/index-by :db/id attachments)
         view-mode (cond
                     (not submitted?) :form-edit-mode
                     guest-role-only? :form-submitted
                     :else :form-read-only)]
     (if-not form-available?
       {:db (-> db
                (assoc-in (model/loading-full-path state-path) false)
                (assoc-in (model/form-available-full-path state-path) false))}
       {:fx [[:dispatch [::initialize
                         {:state-path            state-path
                          :process-id            process-id
                          :template              template
                          :answers               answers
                          :submitted?            submitted?
                          :attachments-by-id     attachments-by-id
                          :tenant-user-access?   (not guest-role-only?)
                          :e-signature-required? e-signature-required?
                          :view-mode             view-mode
                          :date-format           date-format}]]]}))))

(rf/reg-event-fx
 ::load-process-failure
 [rf/trim-v]
 (fn [{:keys [_db]} [_ _resp]]
   (let [])))

(rf/reg-event-fx
 ::load-process
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [process-id state-path]}]]
   (let []
     {:db    (-> db
                 (assoc-in (model/loading-full-path state-path) true)
                 (assoc-in (model/process-id-full-path state-path) process-id))
      :fetch {:uri        (api-path "/load-process")
              :method     :post
              :body       {:process-id process-id}
              :on-success [::load-process-success {:state-path state-path}]
              :on-failure [::load-process-failure {:state-path state-path}]}})))

(rf/reg-event-fx
 ::set-view-mode
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [view-mode state-path]}]]
   {:db (assoc-in db (model/view-mode-full-path state-path) view-mode)}))

(rf/reg-event-fx
 ::cancel-edit-submitted-answers
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [state-path]}]]
   (let [initial-answers (get-in db (model/initial-answers-full-path state-path))]
     {:db (-> db
              (assoc-in (model/view-mode-full-path state-path) :form-read-only)
              (assoc-in (model/answers-full-path state-path) initial-answers))})))

(rf/reg-event-fx
 ::add-signatory
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [state-path] :as ctx}]]
   (let [new-db (-> db
                    (update-in (model/signatories-full-path state-path) (fnil conj []) {:full-name ""
                                                                                        :email     ""}))

         fx (concat
             [[:dispatch [::on-blur-field {:field      :signatories
                                           :state-path state-path}]]]
             (when (and (model/root? db state-path)
                        (model/autosave-on? db state-path))
               [[::trigger-save-answers-timeout ctx]]))]
     {:db new-db
      :fx (vec fx)})))

(rf/reg-event-fx
 ::remove-signatory
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [index state-path] :as ctx}]]
   (let [new-db (-> db
                    (update-in (model/signatories-full-path state-path) (partial cu/vec-remove index)))
         fx (concat
             [[:dispatch [::on-blur-field {:field      :signatories
                                           :state-path state-path}]]]

             (when (and (model/root? db state-path)
                        (model/autosave-on? db state-path))
               [[::trigger-save-answers-timeout ctx]]))]
     {:db new-db
      :fx (vec fx)})))

(rf/reg-event-fx
 ::update-signatory-field
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [field value index state-path] :as ctx}]]
   (let [prev-signatories (get-in db (model/signatories-full-path state-path))
         new-signatories (->> prev-signatories
                              (map-indexed
                               (fn [idx signer]
                                 (if (= idx index)
                                   (assoc signer field value)
                                   signer)))
                              vec)

         new-db (-> db
                    (assoc-in (model/signatories-full-path state-path) new-signatories))

         fx (concat
             (when (and (model/root? db state-path)
                        (model/autosave-on? db state-path))
               [[::trigger-save-answers-timeout ctx]]))]
     {:db new-db
      :fx (vec fx)})))

(rf/reg-event-fx
 ::save-answers-success
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [state-path answers]} _resp]]
   (let [submitted? (get-in db (model/submitted-full-path state-path))]
     (js/console.log "Save answers success!")
     {:db (cond-> db
            true (assoc-in (model/initial-answers-full-path state-path) answers)
            true (assoc-in (model/saving-answers-full-path state-path) false)
            submitted? (assoc-in (model/view-mode-full-path state-path) :form-read-only))})))

(rf/reg-event-fx
 ::save-answers-failure
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [state-path]} resp]]
   (let []
     (js/console.log "Save answers failure " resp)
     {:db (-> db
              (assoc-in (model/saving-answers-full-path state-path) false))})))

(rf/reg-event-fx
 ::save-answers
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [state-path] :as ctx}]]
   (let [process-id (get-in db (model/process-id-full-path state-path))
         answers (get-in db (model/answers-full-path state-path))]
     (js/console.log "Saving answers...")
     {:db (assoc-in db (model/saving-answers-full-path state-path) true)
      :fx [[:fetch {:uri        (api-path "/save-answers")
                    :method     :post
                    :body       {:process-id process-id
                                 :answers    answers}
                    :on-success [::save-answers-success (assoc ctx :answers answers)]
                    :on-failure [::save-answers-failure ctx]}]]})))

(rf/reg-event-db
 ::set-pdf-doc
 [rf/trim-v]
 (fn [db [{:keys [state-path]} pdf-doc]]
   (assoc-in db (model/pdf-doc-full-path state-path) pdf-doc)))

(rf/reg-fx
 ::generate-pdf
 (fn [{:keys [state-path template answers on-success attachments e-signature-required?]}]
   (let [pdf-doc (pdf-util/create-pdf {:template              template
                                       :answers               answers
                                       :attachments           attachments
                                       :e-signature-required? e-signature-required?})]
     (rf/dispatch [::set-pdf-doc {:state-path state-path} pdf-doc])
     (when (vector? on-success)
       (rf/dispatch (conj on-success pdf-doc))))))

(rf/reg-event-fx
 ::generate-pdf
 [rf/trim-v]
 (fn [{:keys [db]} {:keys [state-path]}]
   (let [answers (get-in db (model/answers-full-path state-path))
         template (get-in db (model/template-full-path state-path))
         attachments (get-in db (model/attachments-full-path state-path))
         e-signature-required? (get-in db (model/e-signature-required-full-path state-path))]
     {:fx [[::generate-pdf {:answers               answers
                            :template              template
                            :attachments           attachments
                            :e-signature-required? e-signature-required?}]]})))

(rf/reg-event-fx
 ::validate-answers-and-open-confirm-submit-modal
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [state-path]}]]
   (let [new-db (model/update-field-errors db {:state-path state-path})
         field-errors (get-in new-db (model/field-errors-full-path state-path))]

     (if field-errors
       {:db           (-> new-db
                          (assoc-in (model/show-all-field-errors-full-path state-path) true))
        ::toast/error {:message (loc/tr :fix-form-errors-before-submitting)}}
       {:db new-db
        :fx [[:dispatch [::open-confirmation-modal
                         {:state-path state-path
                          :modal-type :submit-form}]]]}))))

(rf/reg-fx
 ::open-pdf-preview
 (fn [pdf-doc]
   (oops/ocall pdf-doc "open")))

(rf/reg-event-fx
 ::open-pdf-preview
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [state-path]}]]
   (let [pdf-doc (get-in db (model/pdf-doc-full-path state-path))]
     {:fx [[::open-pdf-preview pdf-doc]]})))

(rf/reg-fx
 ::generate-pdf-and-open-preview
 (fn [{:keys [template answers attachments date-format e-signature-required?]}]
   (let [pdf-doc (pdf-util/create-pdf
                  {:template              template
                   :answers               answers
                   :attachments           attachments
                   :date-format           date-format
                   :e-signature-required? e-signature-required?})]
     (oops/ocall pdf-doc "open"))))

(rf/reg-event-fx
 ::generate-pdf-and-open-preview
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [state-path]}]]
   (let [template (get-in db (model/template-full-path state-path))
         attachments (get-in db (model/attachments-full-path state-path))
         e-signature-required? (get-in db (model/e-signature-required-full-path state-path))
         answers (get-in db (model/answers-full-path state-path))
         date-format (get-in db (model/date-format-full-path state-path))]
     {::generate-pdf-and-open-preview {:answers               answers
                                       :template              template
                                       :attachments           attachments
                                       :date-format           date-format
                                       :e-signature-required? e-signature-required?}})))

(rf/reg-fx
 ::upload-pdf-and-submit-form
 (fn [{:keys [template answers date-format attachments process-id
              e-signature-required? await-for-esign-process-start?
              on-success-event on-error-event]}]
   (let [pdf-doc (pdf-util/create-pdf {:template              template
                                       :answers               answers
                                       :date-format           date-format
                                       :attachments           attachments
                                       :e-signature-required? e-signature-required?})]
     (oops/ocall
      pdf-doc
      "getBlob"
      (fn [blob]
        (let [file-name "answers.pdf"
              file (js/File. (array blob) file-name)]
          (async/go
            (let [token-resp (async/<! (http/post (api-path "/create-op-token")))]
              (if-not (:success token-resp)
                (rf/dispatch (conj on-error-event token-resp))
                (let [token (-> token-resp
                                :body
                                :body
                                :token)
                      submit-resp (async/<! (http/post (api-path "/upload-pdf-and-submit-form")
                                                       {:multipart-params
                                                        {:file                           file
                                                         :filename                       (.-name file)
                                                         :token                          token
                                                         :answers                        (pr-str answers)
                                                         :process-id                     process-id
                                                         :await-for-esign-process-start? await-for-esign-process-start?}}))]
                  (if (:success submit-resp)
                    (rf/dispatch (conj on-success-event submit-resp))
                    (rf/dispatch (conj on-error-event submit-resp)))))))))))))

(rf/reg-fx
 ::upload-file
 (fn [{:keys [process-id file filename on-success]}]
   (async/go
     (let [token-resp (async/<! (http/post (api-path "/create-op-token")))]
       (if-not (:success token-resp)
         (js/console.log "Error creating op token for file upload" token-resp)
         (let [token (-> token-resp
                         :body
                         :body
                         :token)

               upload-resp (async/<! (http/post (api-path "/upload-file")
                                                {:multipart-params
                                                 {:file       file
                                                  :filename   filename
                                                  :token      token
                                                  :process-id process-id}}))]
           (rf/dispatch (conj on-success upload-resp))))))))

(rf/reg-event-fx
 ::upload-file-to-field-success
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [field temp-id state-path] :as ctx} resp]]
   (let [attachment (-> resp
                        :body
                        :body
                        (assoc :entity/type :entity.type/attachment))
         attachment-id (:db/id attachment)
         value-path (into state-path [:answers field])
         attachment-path (vec (concat state-path model/attachments-path [attachment-id]))
         new-db (-> db
                    (update-in value-path (fnil conj []) attachment-id)
                    (assoc-in (conj (model/attachments-full-path state-path) attachment-id) attachment)
                    (assoc-in attachment-path attachment)
                    (p/dissoc-in (model/attachment-upload-full-path state-path temp-id))
                    (model/update-field-errors {:fields     [field]
                                                :state-path state-path}))]
     (merge
      {:db new-db}

      (when (and (model/root? db state-path)
                 (model/autosave-on? db state-path))
        {::trigger-save-answers-timeout ctx})))))

(rf/reg-cofx
 ::create-file-temp-ids
 (fn [cofx]
   (let [files (-> cofx
                   :event
                   first
                   :files)
         file-count (oops/oget files "length")
         file-temp-ids (->> file-count
                            range
                            (mapv (fn [index]
                                    [index (uu/make-uuid)]))
                            (into {}))]
     (assoc cofx :file-temp-ids file-temp-ids))))

(rf/reg-event-fx
 ::add-files-to-field
 [rf/trim-v
  (rf/inject-cofx ::create-file-temp-ids)]
 (fn [{:keys [db file-temp-ids]} [{:keys [field state-path files]}]]
   (let [process-id (get-in db (model/process-id-full-path state-path))
         files (->> (oops/oget files "length")
                    range
                    (mapv (fn [index]
                            (let [file (aget files index)
                                  filename (oops/oget file "name")
                                  temp-id (get file-temp-ids index)]
                              {:id         (str "file-" index)
                               :temp-id    temp-id
                               :temp?      true
                               :file       file
                               :filename   filename
                               :field      field
                               :state-path state-path}))))
         files-by-temp-id (->> files
                               (mapv (fn [file]
                                       [(:temp-id file) file]))
                               (into {}))
         new-db (update-in db (into state-path model/attachment-uploads-path) merge files-by-temp-id)]
     {:db new-db
      :fx (->> files
               (mapv (fn [{:keys [file filename temp-id]}]
                       [::upload-file {:file       file
                                       :filename   filename
                                       :process-id process-id
                                       :on-success [::upload-file-to-field-success
                                                    {:field      field
                                                     :temp-id    temp-id
                                                     :state-path state-path}]}])))})))

;; TODO: Should we disable from db?
(rf/reg-event-fx
 ::remove-file-from-field
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [field state-path file-id] :as ctx}]]
   (let [path (into state-path [:answers field])
         prev-value (get-in db path [])
         new-value (->> prev-value
                        (filterv #(not= % file-id)))
         new-db (-> db
                    (assoc-in path new-value)
                    (update-in (model/touched-fields-full-path state-path) (fnil set/union #{}) #{field})
                    (model/update-field-visibilities {:fields     [field]
                                                      :state-path state-path})
                    (model/update-field-errors {:fields     [field]
                                                :state-path state-path}))]
     (merge
      {:db new-db}
      (when (and (model/root? db state-path)
                 (model/autosave-on? db state-path))
        {:fx [[::trigger-save-answers-timeout ctx]]})))))

(rf/reg-event-fx
 ::submit-form-failure
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [state-path]} response]]
   (let [validation-error? (-> response
                               :body
                               :message
                               (= "field-validation-error"))
         new-db (-> db
                    (assoc-in (model/submitting-full-path state-path) false))]
     (cond
       validation-error?
       (let [field-errors (->> response
                               :body
                               :client-friendly-error-data
                               (walk/postwalk (fn [item]
                                                (if (string? item)
                                                  (keyword item)
                                                  item))))]
         {:db           (-> new-db
                            (assoc-in (model/field-errors-full-path state-path) field-errors)
                            (assoc-in (model/show-all-field-errors-full-path state-path) true))
          ::toast/error {:message (loc/tr :fix-form-errors-before-submitting)}
          :fx           [[:dispatch [::close-confirmation-modal {:state-path state-path}]]]})

       :else
       {:db           new-db
        ::toast/error {:message (loc/tr :counterparty-diligence-unknown-error-happened-while-submitting-form)}
        :fx           [[:dispatch [::close-confirmation-modal {:state-path state-path}]]]}))))

(rf/reg-event-fx
 ::submit-form-success
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [state-path]}]]
   {:db (-> db
            (assoc-in (model/submitting-full-path state-path) false)
            (assoc-in (model/view-mode-full-path state-path) :form-submitted)
            (assoc-in (model/submitted-full-path state-path) true))
    :fx [[:dispatch [::close-confirmation-modal {:state-path state-path}]]]}))

(rf/reg-event-fx
 ::submit-form
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [state-path] :as ctx}]]
   (let [process-id (get-in db (model/process-id-full-path state-path))
         template (get-in db (model/template-full-path state-path))
         attachments (get-in db (model/attachments-full-path state-path))
         e-signature-required? (get-in db (model/e-signature-required-full-path state-path))
         answers (get-in db (model/answers-full-path state-path))
         date-format (get-in db (model/date-format-full-path state-path))]
     {:db (-> db
              (assoc-in (model/submitting-full-path state-path) true)
              (assoc-in (conj (model/confirmation-modal-state-full-path state-path) :submitting?) true))
      :fx [[::upload-pdf-and-submit-form
            {:process-id            process-id
             :answers               answers
             :template              template
             :date-format           date-format
             :attachments           attachments
             :e-signature-required? e-signature-required?
             :on-success-event      [::submit-form-success ctx]
             :on-error-event        [::submit-form-failure ctx]}]]})))

(rf/reg-event-fx
 ::open-sheet-form
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [create? field template state-path
                            answers lang-kw sheet-title row-index] :as _args
                     :or {answers {}}}]]
   (let [submit-event (if create?
                        [::add-entity-list-entity
                         {:field      field
                          :state-path state-path}]
                        [::replace-entity-list-entity
                         {:field      field
                          :row-index  row-index
                          :state-path state-path}])

         visible-fields (template-util/resolve-visible-fields
                         {:data                  answers
                          :template              template
                          :e-signature-required? false})

         attachments (get-in db (model/attachments-full-path state-path))

         field-errors (validation/validate-fields {:data          answers
                                                   :template      template
                                                   :entity-lookup (fn [eid]
                                                                    (let [id (or (:db/id eid) eid)]
                                                                      (get attachments id)))})
         show-all-field-errors? (when-not create?
                                  (get-in db (model/show-all-field-errors-full-path state-path)))

         state (-> (get-in db state-path)
                   (assoc-in model/sheet-submit-event-path submit-event)
                   (assoc-in model/root?-path false)
                   (assoc-in model/answers-path answers)
                   (assoc-in model/initial-answers-path answers)
                   (assoc-in model/visible-fields-path visible-fields)
                   (assoc-in model/touched-fields-path #{})
                   (assoc-in model/show-all-field-errors-path show-all-field-errors?)
                   (assoc-in model/template-path template)
                   (assoc-in model/field-errors-path field-errors))]
     {:fx [[:dispatch [::sheet-event/open-sheet {:sheet-key   model/sheet-view-key
                                                 :sheet-group :counterparty-diligence-form
                                                 :state       state
                                                 :props       {:lang-kw     lang-kw
                                                               :template    template
                                                               :sheet-title sheet-title}}]]]})))

(rf/reg-event-fx
 ::dismiss-sheet-form
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [state-path close-sheet-event]}]]
   (let [answers (get-in db (model/answers-full-path state-path))
         initial-answers (get-in db (model/initial-answers-full-path state-path))
         changes? (not= answers initial-answers)]
     (if-not changes?
       {:fx [[:dispatch close-sheet-event]]}
       {:fx [[:dispatch [::open-confirmation-modal
                         {:state-path    state-path
                          :modal-type    :discard-changes
                          :confirm-event close-sheet-event}]]]}))))

(rf/reg-event-fx
 ::submit-sheet-form
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [state-path close-sheet-event]}]]
   (let [answers (get-in db (model/answers-full-path state-path))
         attachments (get-in db (model/attachments-full-path state-path))
         submit-event (get-in db (model/sheet-submit-event-full-path state-path))
         new-db db]
     {:db new-db
      :fx [[:dispatch (conj submit-event {:answers     answers
                                          :attachments attachments})]
           [:dispatch close-sheet-event]]})))

(rf/reg-event-fx
 ::change-field-value
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [field value state-path] :as ctx}]]
   (let [new-db (assoc-in db (model/field-value-full-path state-path field) value)
         fx (concat
             (when (and (model/root? db state-path)
                        (model/autosave-on? db state-path))
               [[::trigger-save-answers-timeout ctx]]))]
     (merge
      {:db new-db}
      (when (seq fx)
        {:fx (vec fx)})))))

(rf/reg-event-fx
 ::on-blur-field
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [field state-path]}]]
   (let [new-db (-> db
                    (update-in (model/touched-fields-full-path state-path) (fnil set/union #{}) #{field})
                    (model/update-field-visibilities {:fields     [field]
                                                      :state-path state-path})
                    (model/update-field-errors {:fields     [field]
                                                :state-path state-path}))]
     {:db new-db})))

(rf/reg-cofx
 ::generate-entity-list-item-id
 (fn [cofx]
   (assoc cofx :entity-id (uu/make-uuid))))

(rf/reg-event-fx
 ::add-entity-list-entity
 [rf/trim-v
  (rf/inject-cofx ::generate-entity-list-item-id)]
 (fn [{:keys [db entity-id]} [{:keys [field state-path] :as ctx} {:keys [answers attachments]}]]
   (let [entity (assoc answers :_id entity-id)
         new-db (-> db
                    (update-in (into state-path [:answers field]) (fnil conj []) entity)
                    (update-in (model/attachments-full-path state-path) merge attachments))

         fx (concat
             [[:dispatch [::on-blur-field {:field      field
                                           :state-path state-path}]]]

             (when (and (model/root? db state-path)
                        (model/autosave-on? db state-path))
               [[::trigger-save-answers-timeout ctx]]))]
     {:db new-db
      :fx (vec fx)})))

(rf/reg-event-fx
 ::replace-entity-list-entity
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [field state-path row-index] :as ctx} {:keys [answers attachments]}]]
   (let [new-db (-> db
                    (assoc-in (into state-path [:answers field row-index]) answers)
                    (update-in (model/attachments-full-path state-path) merge attachments))
         fx (concat
             [[:dispatch [::on-blur-field {:field      field
                                           :state-path state-path}]]]

             (when (and (model/root? db state-path)
                        (model/autosave-on? db state-path))
               [[::trigger-save-answers-timeout ctx]]))]
     {:db new-db
      :fx (vec fx)})))

(rf/reg-event-fx
 ::remove-entity-list-entity
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [field state-path row-index] :as ctx}]]
   (let [new-db (-> db
                    (update-in (into state-path [:answers field]) (partial cu/vec-remove row-index)))
         fx (concat
             [[:dispatch [::on-blur-field {:field      field
                                           :state-path state-path}]]]

             (when (and (model/root? db state-path)
                        (model/autosave-on? db state-path))
               [[::trigger-save-answers-timeout ctx]]))]
     {:db new-db
      :fx (vec fx)})))

(rf/reg-fx
 ::open-attachment
 (fn [{:keys [attachment-id]}]
   (let [w (oops/ocall js/window "open" "about:blank" "_blank")]
     (async/go
       (let [resp (async/<! (http/post (api-path "/attachment-download-url")
                                       {:body (str {:attachment-id attachment-id})}))]
         (if (:success resp)
           (let [download-url (-> resp
                                  :body
                                  :body)]
             (oops/oset! w "location" download-url))
           (js/console.log "Error opening attachment " resp)))))))

(rf/reg-fx
 ::open-attachment-url
 (fn [url]
   (let [w (oops/ocall js/window "open" "about:blank" "_blank")]
     (oops/oset! w "location" url))))

(rf/reg-fx
 ::download-attachment-url
 (fn [url]
   (oops/oset! js/window.location "href" url)))

(rf/reg-event-fx
 ::get-attachment-download-url-success
 [rf/trim-v]
 (fn [_ [{:keys [download?]} resp]]
   (let [url (-> resp
                 :body
                 :body)]
     (if download?
       {::download-attachment-url url}
       {::open-attachment-url url}))))

(rf/reg-event-fx
 ::get-attachment-download-url-error
 [rf/trim-v]
 (fn [_ [_args resp]]
   (js/console.log "Get attachment download url error " resp)))

(rf/reg-event-fx
 ::get-attachment-download-url
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [attachment-id download? state-path]}]]
   (let [process-id (get-in db (model/process-id-full-path state-path))]
     {:fetch {:uri        (api-path "/attachment-download-url")
              :method     :post
              :body       {:process-id      process-id
                           :attachment-id   attachment-id
                           :force-download? download?}
              :on-success [::get-attachment-download-url-success {:state-path state-path}]
              :on-failure [::get-attachment-download-url-error {:state-path state-path}]}})))

(rf/reg-event-fx
 ::open-attachment
 [rf/trim-v]
 (fn [_cofx [{:keys [attachment-id state-path]}]]
   {:fx [[:dispatch [::get-attachment-download-url
                     {:attachment-id attachment-id
                      :download?     false
                      :state-path    state-path}]]]}))

(rf/reg-event-fx
 ::download-attachment
 [rf/trim-v]
 (fn [_ [{:keys [attachment-id state-path]}]]
   {:fx [[:dispatch [::get-attachment-download-url
                     {:attachment-id attachment-id
                      :download?     true
                      :state-path    state-path}]]]}))

;; For testing UI
#_(rf/reg-event-db
   ::toggle-show-field-errors
   [rf/trim-v]
   (fn [db [{:keys [state-path]}]]
     (let [show-all-path (model/show-all-field-errors-full-path state-path)
           hide-all-path (model/hide-all-field-errors-full-path state-path)

           show-all? (get-in db show-all-path)
           hide-all? (get-in db hide-all-path)

           new-db (cond
                    (and (not show-all?)
                         (not hide-all?))
                    (-> db
                        (assoc-in show-all-path true)
                        (assoc-in hide-all-path false))

                    show-all?
                    (-> db
                        (assoc-in show-all-path false)
                        (assoc-in hide-all-path true))

                    hide-all?
                    (-> db
                        (assoc-in show-all-path false)
                        (assoc-in hide-all-path false)))]
       new-db)))

(rf/reg-fx
 ::set-confirmation-modal-open
 (fn [{:keys [open? state-path on-success]}]
   (let [modal-id (model/confirmation-modal-id state-path)
         modal (oops/ocall js/document "getElementById" modal-id)]
     (if open?
       (oops/ocall modal "showModal")
       (oops/ocall modal "close"))
     ;; HACK: So that user can interact with confirmation modal,
     ;; even in cases where radix ui dialog/sheet is open.
     ;; Investigate if we can get this working without hack
     (oops/oset! js/document "!body.!style.!pointerEvents" "")
     (when (vector? on-success)
       (rf/dispatch on-success)))))

(rf/reg-event-fx
 ::open-confirmation-modal
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [state-path modal-type props confirm-event]}]]
   (let [modal-state {:props         props
                      :modal-type    modal-type
                      :confirm-event confirm-event}]
     {:db (assoc-in db (model/confirmation-modal-state-full-path state-path) modal-state)
      :fx [[::set-confirmation-modal-open {:open?      true
                                           :state-path state-path}]]})))

(rf/reg-event-fx
 ::clear-confirmation-modal-state
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [state-path]}]]
   {:db (p/dissoc-in db (model/confirmation-modal-state-full-path state-path))}))

(rf/reg-event-fx
 ::close-confirmation-modal
 [rf/trim-v]
 (fn [_cofx [{:keys [state-path] :as ctx}]]
   {:fx [[::set-confirmation-modal-open
          {:open?      false
           :state-path state-path
           :on-success [::clear-confirmation-modal-state ctx]}]]}))
